import { Component, inject, OnInit } from '@angular/core';
import Store from '@mysrc/app/store';
import {
  ATTACHMENT_ACTION,
  REQUEST_ACTION,
  TABLE_INFO,
} from '@mysrc/app/store/app.action';
import { ActionItem, TableInformation } from '@mysrc/models/approval-hub.model';
import { SharedDialogService } from '@mysrc/services/framework/shared-dialog.service';
import { map } from 'rxjs/operators';
import { formatSnakeCase } from '../../handlers/utils';
import { DialogFieldType } from '@mysrc/models/shared-dialog';
import { FileUploadDialogComponent } from '../../components';
import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { GridModule, KENDO_GRID } from '@progress/kendo-angular-grid';
import { OktaWrapperService } from '@mysrc/services/framework';
import { FormsModule } from '@angular/forms';
import { KENDO_PAGER } from '@progress/kendo-angular-pager';
import {
  DropDownListModule,
  KENDO_DROPDOWNLIST,
} from '@progress/kendo-angular-dropdowns';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { PageChangeEvent } from '@progress/kendo-angular-listview';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  imports: [
    AsyncPipe,
    NgIf,
    NgFor,
    NgClass,
    GridModule,
    TextBoxModule,
    DropDownListModule,
    FormsModule,
  ],
  standalone: true,
})
export class HomePageComponent {
  public pageSize = 10;
  public skip = 0;

  public sizes = [10, 20, 50];
  readonly store = inject(Store);
  readonly sharedDialog = inject(SharedDialogService);

  subCategories$ = this.store.subCategories$;
  activeSubCategory$ = this.store.activeSubCategory$;
  dataSource$ = this.activeSubCategory$.pipe(map((d) => d?.data || []));
  activeTableConfig$ = this.store.activeSubCategory$.pipe(
    map((d) => d?.config || [])
  );
  displayColumns$ = this.activeTableConfig$.pipe(
    map((d) => ['select', 'actions', ...d.map((c) => c.key)])
  );

  constructor(readonly oktaWrapper: OktaWrapperService) {
    oktaWrapper.currentUser$.subscribe((d) => {
      d && this.store.dispatch(TABLE_INFO.tableDetails());
    });
  }

  public pageSizeChange(value: any): void {
    this.skip = 0;
    // this.loadItems();
  }

  public startnum() {
    return this.skip + 1;
  }

  public endnum(total: number) {
    return Math.min(this.skip + this.pageSize, total);
  }

  openConfirmationDialog(
    row: ActionItem,
    metaData: TableInformation,
    action: 'approve' | 'reject'
  ) {
    const formData = {
      tableWholeData: metaData,
      sys_id: row.sys_id,
      comments: '',
      formData: {} as { [k: string]: any },
    };
    const acceptFields = [
      ...(metaData.additional_approval_field
        ? [
            {
              key: metaData.additional_approval_field,
              label: formatSnakeCase(metaData.additional_approval_field),
              type: 'input' as DialogFieldType,
              value: '',
              required: true,
            },
          ]
        : []),
      ...(metaData.approval_comment_field
        ? [
            {
              key: metaData.approval_comment_field,
              label: formatSnakeCase(metaData.approval_comment_field),
              type: 'textarea' as DialogFieldType,
              value: '',
              required: true,
            },
          ]
        : []),
    ];
    const rejectionFields = [
      ...(metaData.additional_rejection_field
        ? [
            {
              key: metaData.additional_rejection_field,
              label: formatSnakeCase(metaData.additional_rejection_field),
              type: 'input' as DialogFieldType,
              value: '',
              required: true,
            },
          ]
        : []),
      ...(metaData.rejection_comment_field
        ? [
            {
              key: metaData.rejection_comment_field,
              label: formatSnakeCase(metaData.rejection_comment_field),
              type: 'textarea' as DialogFieldType,
              value: '',
              required: true,
            },
          ]
        : []),
    ];

    if (action == 'approve' && acceptFields.length == 0) {
      return this.store.dispatch(
        REQUEST_ACTION.approveRequest({ data: formData })
      );
    } else if (action == 'reject' && rejectionFields.length == 0) {
      return this.store.dispatch(
        REQUEST_ACTION.rejectRequest({ data: formData })
      );
    } else {
      this.sharedDialog
        .openDialog(
          {
            cssClass: 'modal-header-title-blue',
            title: `${
              action === 'approve'
                ? row.approve_action_label || 'Approve'
                : row.reject_action_label || 'Reject'
            } Request`,

            actions: [
              {
                text: 'Submit',
                value: action,
                type: 'submit',
                cssClass: 'btn btn-primary isg-dialog-button k-rounded-md-zero',
              },
              {
                text: 'Cancel',
                value: 'cancel',
                type: 'button',
                cssClass:
                  'btn btn-primary2 isg-dialog-button k-rounded-md-zero',
              },
            ],
          },
          {
            mode: 'form',
            fields: [
              ...(action === 'approve' ? acceptFields : rejectionFields),
            ],
          }
        )
        .subscribe((dialogRes) => {
          const { form, action } = dialogRes;
          if (['approve', 'reject'].includes(action)) {
            formData.formData = form;
            if (action == 'approve') {
              this.store.dispatch(
                REQUEST_ACTION.approveRequest({ data: formData })
              );
            } else if (action == 'reject') {
              this.store.dispatch(
                REQUEST_ACTION.rejectRequest({ data: formData })
              );
            }
          } else {
            //   this.store.dispatch(REQUEST_ACTION.rejectRequest({ slaSummaryId: row.slaSummaryId, comments }));
          }
        });
    }
  }

  openAttachmentDialog(row: ActionItem, metaData: TableInformation) {
    console.log('Open attachment dialog', row, metaData);
    this.store.dispatch(
      ATTACHMENT_ACTION.fetchAttachments({ sysId: row.sys_id })
    );
  }

  onFilter(input: HTMLInputElement) {
    console.log(input);
  }
  public pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
  }
}
